import { ThemeProvider } from "@mui/material";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import DoctorAnalysisList from "../../../components/screen/patientCare/patientCareDoctorAnalysis/DoctorAnalysisList";
import { theme } from "../../../components/constants/muiTheme";

const DoctorAnalysisListPage = () => {
  return (
    <PageTemplate
      header="Doctor Analysis"
      mainComponent={
        <ThemeProvider theme={theme}>
          <DoctorAnalysisList />
        </ThemeProvider>
      }
      pageRole={19}
    />
  );
};

export default HOC(DoctorAnalysisListPage);
